import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SidePanel, SidePanelBody, SidePanelHeader, SidePanelFooter } from '@gpstrackit/gtc-react-controls';
import { NotificationManager } from 'Components/Notifications';

import { Button, Modal, TabContainer, Tabs, } from '@gpstrackit/gtc-react-controls';
import { validateJsonObject } from '../../../../../../core/data/Helpers';;
import { useIntl } from 'react-intl';
import moment from 'moment';
import EditPanelForm from './editPanelForm';
import DOMPurify from "dompurify";

// Actions
import {
    drawGetDirections,
    hideToggleSidebar,
    routesCreateUpdateRoute,
    routesEtaCreateUpdateEtaLink,
    routesAlertsGetEvents,
    routesEtaDeleteEtaLink,
    catalogLoad,
    routesEtaSearchEtaLinks
} from 'Redux/actions';

import {
    onOpenModalConfirmationSave
} from './redux/slice'

import {
    reset as resetModalCreateEditRoute
} from "../../../../../../modules/realtimeMaps/main/components/routes/components/modalCreateEditRoute/redux/slice"
import { reset as clearCreateEditRoutePoint } from '../createEditRoutePoint/redux/slice'
import { reset as resetCreateEditModalMain } from '../createEditRouteModalMain/redux/slice'
import { reset as resetEditPanelRoute } from './redux/slice'
import { reset as resetDeleteRoutePoint } from '../deleteRoutePoint/redux/slice'
import { reset as resetDeleteRoute } from '../deleteRoute/redux/slice'
import { reset as resetEtaLink } from '../etaRoutes/redux/slice'
import { openModalRouteDirections } from '../modalDirections/redux/slice'
import { getDateFromReactCalendarToUtc } from '../../../../../../components/Map/utils'

import RouteEtaRoutes from '../etaRoutes'
import RouteAlertWatchers from '../alertWatchers'

const ROUTES_NEW_ROUTE_FORM = {
    startingLoad: false,
    color: '#8677D9',
    avoidToll: false,
    optimized: false,
    isTemplate: false,
    useDriverApp: true,
    points: [],
    
    //Eta link control
    etaLink: false,
    etaData: {
        etaLinkId: 0,
        shareCamera: false,
        contactsEta: [],
        notes: ''
    },

    // Alert Watchers
    loadWatchers: false,
    alert: false,
    alertTypeCodes: [], //alert event codes ['RouteDeviation', 'RouteStart', 'RouteEnd']
    copyEtaRecipients: true,
    alertSubscribers: []
};

// Definir las propiedades que queremos comparar
const keysToCompareRoutes = [
    "id", "name", "address", "city", "state", 
    "landmarkId", "latitude", "longitude", "radius", 
    "sequence", "note", "typePoint"
];

const defaultColor = '8677D9';

const EditPanelRoute = (props) => {

    const { showEditPanel, hiddenButton, title, closeEditPanel, mapRef, isRealtimeMaps } = props

    const { messages, locale } = useIntl();
    const childRef = useRef();

    const [formData, setFormData] = useState({ ...ROUTES_NEW_ROUTE_FORM });
    const [dataPointsFromMap, setDataPointsFromMap] = useState({})
    const [searchEtaLink, setSearchEtaLink] = useState(false)

    const loadingSavedRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.loadingSavedRoute);
    const routeId = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.routeId);
    const timeZoneUser = useSelector((state) => state.securityRedux.user.timeZone);
    const loading = useSelector(state => state.routesManagerEditPanelRouteRedux?.loadingRoute);
    const loadingEta = useSelector(state => state.routesManagerEditPanelRouteEtaRoutesRedux?.loading);
    const openModalConfirmationSave = useSelector(state => state.routesManagerEditPanelRouteRedux?.openModalConfirmationSave);
    const changesToSave = useSelector(state => state.routesManagerEditPanelRouteRedux?.changesToSave);
    const changesToSavePoints = useSelector(state => state.routesManagerEditPanelRouteRedux?.changesToSavePoints);
    const route = useSelector(state => state.routesManagerEditPanelRouteRedux?.route);
    const erorrRoutes = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux.erorrRoutes);
    const routeEtaLink = useSelector(state => state.routesManagerEditPanelRouteEtaRoutesRedux?.routeEtaLink);
    const isRoutesTrackerRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.isRoutesTracker);
    const isRoutesTrackerRealtime = useSelector(state => state.realtimeMapsRoutesModalCreateEditRoute?.isRoutesTracker);
    const isRoutesTracker = isRoutesTrackerRoute || isRoutesTrackerRealtime;

    const paramIsTemplateRoutesModalMain = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.isTemplate);
    const paramIsTemplateRealtimeMapsRoutes = useSelector(state => state.realtimeMapsRoutesModalCreateEditRoute?.isTemplate);
    const paramIsTemplate = paramIsTemplateRoutesModalMain || paramIsTemplateRealtimeMapsRoutes || false;

    const isCloneRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.isCloneRoute);
    const contacts = useSelector(state => state.catalogsRedux.contacts);
    const loadingContacts = useSelector(state => state.catalogsRedux.loadingContacts);

    const [disabledSave, setDisableSave] = useState(false);
    const [numberTab, setNumberTab] = useState(0);
    const [pointUnsaved, setPointUnsaved] = useState(false);

    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(catalogLoad(["drivers"], true))
        dispatch(catalogLoad(['contacts']));
        dispatch(routesAlertsGetEvents());
        if(!isRealtimeMaps){
            dispatch(hideToggleSidebar(true))
        }
        return () => {
            closeModal()
        }
    },[])
    
    useEffect(() => {
        if (formData && childRef?.current) {  
          childRef.current.refreshDirections(formData);
        }
    }, [formData?.points, formData?.avoidToll, formData?.drawLineRoute/* , data?.open */]);

    useEffect(()=> {
        if(loadingSavedRoute && routeId > 0){
            //send to save the new Eta Link
            saveEtaLink(routeId)
        }
    },[loadingSavedRoute, routeId])

    useEffect(()=>{
        if(formData?.systemAlert?.subscribersJSON && !formData?.loadWatchers){
            let sharedWith = formData?.systemAlert?.subscribersJSON ? validateJsonObject(formData?.systemAlert?.subscribersJSON) : ''
            sharedWith = sharedWith ? validateJsonObject(sharedWith) : ''
            const alertSubscribers = getAlertContacts(sharedWith);

            let alertTypeCodes = []
            if(formData?.systemAlert?.configJSON){
                let configJSON = formData?.systemAlert?.configJSON ? validateJsonObject(formData?.systemAlert?.configJSON) : '';
                alertTypeCodes = configJSON?.routeWatchers;
            }
            setFormData(formData => ({ ...formData, alertSubscribers: alertSubscribers,  loadWatchers: true, alert: alertTypeCodes?.length > 0 ? true : false, alertTypeCodes: alertTypeCodes }))
        }
    },[formData?.systemAlert?.subscribersJSON])

    useEffect(()=> {
        if(formData?.id > 0 && !searchEtaLink && isRoutesTracker){
          const searchEtaLinks = {
              routeId: formData?.id
          }
          setSearchEtaLink(true)
          dispatch(routesEtaSearchEtaLinks(searchEtaLinks))
        }
    },[formData?.id])
  
    useEffect(()=> {
        if(routeEtaLink){
            const data = routeEtaLink && routeEtaLink?.items && routeEtaLink.items.length > 0 ? routeEtaLink.items[0] : null
            if(data){
                //preveng the multiple get information about the eta link with this setState.
                setFormData(formData => ({
                    ...formData, 
                    etaLink: true,
                    etaData: {
                        ...formData.etaData,
                        etaLinkId: data.id,
                        eta: data.eta,
                        notes: data.notes,
                        shareCamera: data?.scheduleSnapshot,
                        contactsEta: data?.sharedWith ? getEtaContacts(data?.sharedWith) : []
                    }
                }));
            }else{
                setFormData(formData => ({ ...formData }))
            }
        }
    },[routeEtaLink])

    //Get the contacts from the sharedWith
    const getAlertContacts = (sharedWith) => {

        let currentContacts = []
        if (sharedWith.length > 0) {
            sharedWith?.forEach((item) => {
                //if have contactId, get the contact from the contacts list
                if(item?.contactId > 0){
                    let currentContact = contacts.find((contact) => contact?.id === item?.contactId)
                    if (currentContact?.id) {
                        currentContacts.push({
                            id: currentContact?.id,
                            value: currentContact?.address,
                            type: "CONTACT",
                            contactType: currentContact?.type
                        })
                    }
                }

                //if have email or sms, add the contact to the list
                if(item?.address){
                    currentContacts.push({
                        id: item?.contactId,
                        value: item?.address,
                        type: item?.type === "email" ? "EMAIL" : item?.type === "cellphone" ? "SMS" : "",
                        contactType: ""
                    })
                }
            })
        }
        return currentContacts;
    }

    /* ------------------------------------------------------------------------------------------------
     * Set the contacts with the ContactsSelector control
     * @param {*} data form dataBase
     * @returns {Object} with format contact to ContactsSelector alertSubscribers
     ------------------------------------------------------------------------------------------------ */
    const getEtaContacts = (sharedWith) => {
        let currentContacts = []
        if (sharedWith?.contacts?.length) {
            sharedWith?.contacts.map((item) => {
                let currentContact = contacts.find((contact) => contact?.id === item)
                if (currentContact?.id) {
                    currentContacts.push({
                        id: currentContact?.id,
                        value: currentContact?.address,
                        type: "CONTACT",
                        contactType: currentContact?.type
                    })
                }
            })
        }
        if (sharedWith?.emails?.length) {
            sharedWith?.emails.map((item) => {
                currentContacts.push({
                    id: item,
                    value: item,
                    type: "EMAIL",
                    contactType: ""
                })
            })
        }
        if (sharedWith?.sms?.length) {
            sharedWith?.sms.map((item) => {
                currentContacts.push({
                    id: item,
                    value: item,
                    type: "SMS",
                    contactType: ""
                })
            })
        }
        return currentContacts
        
    }


    const handleToggle = () => {
        closeEditPanel && closeEditPanel(!showEditPanel)
    }

    const onSaveChanges = () => {

        //save the state value
        saveRouteChages()
        
    }

    const saveEtaLink = (paramRouteId) => {
        const newEtaLinkId = paramRouteId ? paramRouteId : formData?.id;

        //is route template not save information about ETA link
        if(paramIsTemplate && (loadingSavedRoute || !erorrRoutes)){
            closeModal()
            return;
        }
        
        if(!newEtaLinkId){
            //cant save the eta link without routeId.
            closeModal()
            return;
        }

        if(formData?.etaLink){

            //Take the route according to the programation, scheduled field
            let start = getDateFromReactCalendarToUtc(formData?.scheduledAt, timeZoneUser);
            //let start = moment().set("second", 0).add(1, 'hour').toISOString();
            let end = moment(start).add(4, 'days').toISOString();

            let dateRange = {
                start: start, // fleet.etas.startDate: start-date
                end: end // fleet.etas.expirationDate: end-date
            }
            let etaValue = dataPointsFromMap?.etaRouteDurationValue;

            let newEtaLink = {
                entityId: newEtaLinkId,
                entityName: 'Route',
                id: formData?.etaData?.etaLinkId,
                scheduleSnapshot: formData.etaData?.shareCamera ? true : false,
                eta: `${etaValue}`, // get the eta for the route.
                sharedWith: {
                    contacts: formData?.etaData?.contactsEta?.filter(c => c?.type === "CONTACT")?.map(c => parseInt(c?.id)) || [],
                    emails: formData?.etaData?.contactsEta?.filter(c => c?.type === "EMAIL")?.map(c => c?.value) || [],
                    sms: formData?.etaData?.contactsEta?.filter(c => c?.type === "SMS")?.map(c => `${c?.value}`) || [],
                },

                notes: formData?.etaData?.notes || '',

                //data by default
                unitId: 0, //
                address: '',
                latitude: 0,
                longitude: 0,
                dateRange: formData?.etaData?.dateRange || dateRange
            }

            if(formData?.etaData?.etaLinkId == 0){
                delete newEtaLink['id'];
            } 

            dispatch(routesEtaCreateUpdateEtaLink(newEtaLink))
        }

        //send to the delete eta link
        if(!formData?.etaLink && formData?.etaData?.etaLinkId > 0){
            dispatch(routesEtaDeleteEtaLink({ id: formData?.etaData?.etaLinkId }))
        }

        if(loadingSavedRoute || !erorrRoutes){
            closeModal()
        }
    }

    const onDisableSave = (value) => {
        setDisableSave(value)
    }

    const closeModal = () => {
        setFormData({ ...ROUTES_NEW_ROUTE_FORM });
        dispatch(clearCreateEditRoutePoint())
        dispatch(resetCreateEditModalMain())
        dispatch(openModalRouteDirections({open: false}));
        dispatch(resetModalCreateEditRoute())
        dispatch(resetEditPanelRoute())
        dispatch(resetEtaLink())
        if(!isRealtimeMaps){
            dispatch(hideToggleSidebar(false))
        }
        
        dispatch(resetDeleteRoutePoint())
        dispatch(resetDeleteRoute({ openModal: false }))
        dispatch(drawGetDirections(false));
        setFormData({ ...ROUTES_NEW_ROUTE_FORM })
        
    }

    /* ----------------------------------------------------------------------------------------------------------------
     * Perform the action to save information for routes, this method make a insert and updates routes.
     ---------------------------------------------------------------------------------------------------------------- */
    const saveRouteChages = () => {
        let colorToRoute = formData.color.replace('#', '')
        colorToRoute = colorToRoute ? `#${colorToRoute}` : `#${defaultColor}`

        //if have eta values create a new alert watchers for the alert.
        let alertSubscribers = [];
        if(formData?.alertSubscribers && formData?.alertSubscribers.length > 0){
            formData?.alertSubscribers?.filter(c => c?.type === "CONTACT")?.forEach((x) =>{
                alertSubscribers.push({
                    "id": null,
                    "contactId": x?.id || 0,
                    "alert": true,
                    "alertBefore": false,
                    "alertAfter": false,
                    "type": null,
                });
            });

            formData?.alertSubscribers?.filter(c => c?.type === "EMAIL" || c?.type === "SMS")?.forEach((x) =>{
                alertSubscribers.push({
                    "id": null,
                    "contactId": 0,
                    "alert": true,
                    "alertBefore": false,
                    "alertAfter": false,
                    "type": x?.type === "EMAIL" ? "email" : x?.type === "SMS" ? "cellphone" : x?.type || null,
                    "address": x?.value || null,
                });
            });
        }
  
        let pointsOnMap = [...route?.points]
        if(pointsOnMap?.length > 0){
            //adding attributes to the route points before the saving, it's important to make the calc to distance of route (distanceMeters)
          pointsOnMap = pointsOnMap?.map((element, index) => {
            return {
              id: !isCloneRoute ? element.id : 0,
              routeId: element.routeId,
              name: element.name || element.address,
              address: element.address,
              city: element.city,
              state: element.state,
              landmarkId: element.landmarkId,
              latitude: element.latitude,
              longitude: element.longitude,
              radius: element.radius,
              sequence: element.sequence,
              note: element.note,
              typePoint: element.typePoint,
              distanceMeters: dataPointsFromMap?.length > 0 && dataPointsFromMap?.length < index ? dataPointsFromMap?.points[index]?.distance?.value : 0
            }
          })
        }

        const formattedDateInUTC = getDateFromReactCalendarToUtc(formData?.scheduledAt, timeZoneUser);

        let dataToSave = {
          ...formData,
          points: pointsOnMap,
          title: formData?.title?.trim(),
          color: colorToRoute,
          optimized: false, //always optimized is send on false, the check is changed for a button
          avoidToll: formData.avoidToll || false,
          scheduledAt: !paramIsTemplate ? formattedDateInUTC ? formattedDateInUTC : null : null, //send the scheduleAt in null it is template is true.
          isTemplate: paramIsTemplate || false,
          templateRouteId: formData?.templateRouteId || 0,
          distanceMeters: dataPointsFromMap?.distanceMeters || 0,
          alertSubscribers: formData?.alert && alertSubscribers.length > 0 ? alertSubscribers : [],
          alertTypeCodes: formData?.alert ? formData?.alertTypeCodes : [],
          useDriverApp: formData?.useDriverApp ? 1 : 0,
          closeWithLastStop: paramIsTemplate ? 0 : formData?.closeWithLastStop ? 1 : 0,
          closeWithAllStops: paramIsTemplate ? 0 : formData?.closeWithAllStops ? 1 : 0,
          closeMinsAfterActivated: paramIsTemplate ? 0 : !formData?.checkCloseMinsAfterActivated ? 0 : formData?.closeMinsAfterActivated > 0 ? formData?.closeMinsAfterActivated * 60 : 0,
          drivingDirectionsMins: dataPointsFromMap?.etaRouteDurationValue // duration time in minutes
        }
        //compare the initial array points with new array to saw diferences.
        let compareChangesInRoutePoints = isEqualRoutePoints(formData?.pointsFromServer, route?.points, keysToCompareRoutes);

        //Remove the points if it doesn't have changed
        if(!changesToSavePoints && compareChangesInRoutePoints){
            delete dataToSave['points'];
        }

        if(isCloneRoute){
          //remove the id route to Create(clone) a new route
          delete dataToSave['id'];
          dispatch(routesCreateUpdateRoute(dataToSave));
          return
  
        }else{
          dispatch(routesCreateUpdateRoute(dataToSave));
        }
        
    }

    /**------------------------------------------------------------------------------------------
     * Return is the object property is included into keysToKeep
     * @param {object} obj 
     * @param {arrays} keysToKeep 
     * @returns Object with properties
     ------------------------------------------------------------------------------------------*/
    const filterObject = (obj, keysToKeep) => {
        return Object.fromEntries(
            Object.entries(obj).filter(([key]) => keysToKeep.includes(key))
        );
    };

    /*------------------------------------------------------------------------------------------
     * Compare the arrays for route points before the send elements to database
     * @param {*} arr1 first array
     * @param {*} arr2 second array to compare
     * @returns true is equal arrays
     ------------------------------------------------------------------------------------------*/
    const isEqualRoutePoints = (arr1, arr2, keysToCompare) => {
        if (arr1?.length !== arr2?.length) return false;
    
        return arr1.every(item1 => 
            arr2.some(item2 => 
                JSON.stringify(filterObject(item1, keysToCompare)) === 
                JSON.stringify(filterObject(item2, keysToCompare))
            )
        );
    };


    const isEdit = route?.id > 0 && !isCloneRoute ? true : false;

    //the route can't be saved without route points
    const disabledSavedPoints = !route?.points || route?.points?.length < 2 || (route?.points.length > 1 && route?.points.filter((x) => x.typePoint == "Stop")?.length == 0) ? true : false;

    //is enabled Eta Link validate saved contact
    const disabledSaveEtaLink = formData?.etaLink && (!formData?.etaData?.contactsEta || formData?.etaData?.contactsEta?.length == 0) ? true : false;

    //is disabled the save button without alert watchers is enabled and not have contacts
    let disabledSaveAlertWatchers = formData?.alert && (!formData?.alertSubscribers || formData?.alertSubscribers?.length == 0) ? true : false;

    //add the validation into disabledSaveAlertWatchers with the alertTypeCodes
    disabledSaveAlertWatchers = !disabledSaveAlertWatchers && formData?.alert && (!formData?.alertTypeCodes || formData?.alertTypeCodes?.length == 0) ? true : disabledSaveAlertWatchers;


    return (
        <div id='idPanelRouteModal'>
        <SidePanel 
            isOpen={showEditPanel} 
            onToggle={handleToggle} 
            hiddenButton={hiddenButton} 
            style={{ width: '500px', transform: 'translateX(500px)', top: isRealtimeMaps ? 0 : '' }} 
            loading={loading || loadingEta}
            //position={"right"}
            //classSidePanel={args.classSidePanel}
            //classPanelContent={args.classPanelContent}
            //contentStyle={args.contentStyle}
        >
            <SidePanelHeader>
                <h2 style={{ margin: 0, fontFamily: '"Outfit",sans-serif' }}>{isEdit ? `${messages['fsmRoute_edit_panel_route_accordion_edit']} ${title}` : title}</h2> 
            </SidePanelHeader>
            <SidePanelBody id='id_sidePanel' style={{ height: '90%' }}>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    }}
                >
                    <div style={{ width: '100%' }}>

                        {
                            paramIsTemplate
                            ?
                            <EditPanelForm 
                                ref={childRef}
                                editMode={isEdit} 
                                mapRef={mapRef} 
                                onDisableSave={onDisableSave} 
                                isRealtimeMaps={isRealtimeMaps}
                                formData={formData}
                                setFormData={setFormData}
                                setDataPointsFromMap={setDataPointsFromMap}
                                dataPointsFromMap={dataPointsFromMap} 
                                setPointUnsaved={setPointUnsaved}
                            />
                            :
                            <Tabs
                                tab={numberTab}
                                style={{ marginTop: "18px" }}
                                onChange={(TabNum)=>{
                                    setNumberTab(TabNum)
                                }}
                                loading={loadingEta}
                            >
                                <TabContainer label={messages['routes_menu_settings']} index={0}>
                                    {/* Body for modal */}
                                    <EditPanelForm 
                                        ref={childRef}
                                        editMode={isEdit} 
                                        mapRef={mapRef} 
                                        onDisableSave={onDisableSave} 
                                        isRealtimeMaps={isRealtimeMaps} 
                                        formData={formData}
                                        setFormData={setFormData}
                                        setDataPointsFromMap={setDataPointsFromMap} 
                                        dataPointsFromMap={dataPointsFromMap}
                                        setPointUnsaved={setPointUnsaved}
                                    />
                                </TabContainer>
                                
                                <TabContainer label={!loading && !loadingEta && isRoutesTracker ? messages['routes_menu_routes'] : ''} index={1} >
                                    <RouteEtaRoutes formData={formData} setFormData={setFormData} />
                                </TabContainer>                                
                                <TabContainer label={!loading && !loadingEta && isRoutesTracker ? messages['routes_menu_alerts'] : ''} index={2}>
                                    <RouteAlertWatchers formData={formData} setFormData={setFormData} />
                                </TabContainer>
                            </Tabs>
                        }
                        
                    </div>
                </div> 
            </SidePanelBody>
            <SidePanelFooter>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    }}
                >
                    <Button
                        variant="secondary"
                        style={{ marginRight: 8 }}
                        onClick={() => {
                            if(changesToSave && !pointUnsaved){
                                dispatch(onOpenModalConfirmationSave(true))
                            }else{
                                closeModal()
                            }
                        }}
                    >
                        {messages['routes_cancel']}
                    </Button>
                    <Button
                        variant="primary"
                        isDisabled={loadingEta || disabledSave || loadingSavedRoute || loading || disabledSavedPoints || disabledSaveEtaLink || disabledSaveAlertWatchers}
                        onClick={(e) => {
                            e.preventDefault();
                            if(pointUnsaved){
                                dispatch(onOpenModalConfirmationSave(true))
                            } else{
                                onSaveChanges();
                            }
                        }}
                    >
                        {messages['routes_save']}
                    </Button>
                </div>      
            </SidePanelFooter>
        </SidePanel>
        {
            (!pointUnsaved && openModalConfirmationSave) &&
            <Modal
                title={messages['fsmRoute_edit_panel_route_close_confirmation_modal_title']}
                open={openModalConfirmationSave}
                loading={loading}
                position="center"
                size="small"
                closeButton={false}
                className='design-form-modal-height'
                footer={(
                    <div style={{ display: 'flex', alignItems: "center", justifyContent: 'end', width: '100%' }}>
                        <Button
                            disabled={loading}
                            style={{ marginRight: 8 }}
                            onClick={() => dispatch(onOpenModalConfirmationSave(false))}
                            variant='secondary'
                        >
                            {messages['back']}
                        </Button>

                        <Button
                            disabled={loading}
                            onClick={() => {
                                closeModal();
                                dispatch(onOpenModalConfirmationSave(false));
                            }}
                            variant='primary'
                        >
                            {messages['close']}
                        </Button>
                    </div>
                )}
            >
                <div style={{ padding: 20 }}>
                    {messages['fsmRoute_edit_panel_route_close_confirmation_modal']}
                </div>
            </Modal>
        }
        {
            (pointUnsaved && openModalConfirmationSave) && 
            <Modal
                title={messages['fsmRoute_edit_panel_route_close_validation_new_point_title']}
                open={openModalConfirmationSave}
                loading={loading}
                position="center"
                size="small"
                closeButton={false}
                className='design-form-modal-height'
                footer={(
                    <div style={{ display: 'flex', alignItems: "center", justifyContent: 'end', width: '100%' }}>
                        <Button
                            disabled={loading}
                            style={{ marginRight: 8 }}
                            onClick={() => dispatch(onOpenModalConfirmationSave(false))}
                            variant='secondary'
                        >
                            {messages['fsmRoute_edit_panel_route_close_validation_return']}
                        </Button>

                        <Button
                            disabled={loading}
                            onClick={() => {
                                dispatch(onOpenModalConfirmationSave(false));
                                onSaveChanges();
                            }}
                            variant='primary'
                        >
                            {messages['fsmRoute_edit_panel_route_close_validation_continue']}
                        </Button>
                    </div>
                )}
            >
                <div style={{ padding: '5px 20px' }}>
                    {messages['fsmRoute_edit_panel_route_close_validation_new_point']}
                </div>
                <div 
                    style={{
                        position: 'relative',
                        paddingLeft: '20px',
                        margin: '8px 0'
                    }}
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(`• ${messages['fsmRoute_edit_panel_route_close_validation_new_point_continue']
                            .replace(
                                '{will not be saved}', 
                                `<span style="font-weight: bold;">${messages['fsmRoute_edit_panel_route_close_validation_new_point_continue_will_not']}</span>`
                            )}`)
                    }}
                />
                <div style={{
                    position: 'relative',
                    paddingLeft: '20px',
                    margin: '8px 0'
                }}>
                    • {messages['fsmRoute_edit_panel_route_close_validation_new_point_add']}
                </div>
                <div style={{ padding: 20 }}>
                    {messages['fsmRoute_edit_panel_route_close_validation_new_point_question']}
                </div>
            </Modal>

        }
        </div>
    )
}




export default EditPanelRoute;